
export default {
  components: {
    highcharts: () =>
      Promise.all([
        import('highcharts'),
        import('highcharts/modules/stock'),
        import('highcharts-vue'),
      ]).then(([{ default: Highcharts }, { default: Stock }, { Chart }]) => {
        Stock(Highcharts)
        return Chart
      }),
  },
  props: {
    options: {
      type: Object,
      required: true,
    },
  },
}
